import styled from 'styled-components'
import { BREAK_POINT_MD } from '@CSSVars/variables'

export const _AlertLeadSearch = styled.div`
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  > div {
    flex-shrink: 0;
    width: 100%;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    align-items: flex-start;
  }
`

export const _InputWrap = styled.div`
  width: 310px;
  margin: 4px auto;
  input {
    width: 100%;
    height: 48px;
    padding: 5px;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    padding:0;
    margin: 4px 0 0 0;
  }
`
